import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberIdentifier } from '@app/core/_models/member-interface';
import { MemberService, PublicInfoResponse } from '@app/core/members/member.service';
import { saveIdentifierToStorage } from '@app/+login/deprecated-hybrid/helpers';

@Injectable({
  providedIn: 'root',
})
export class LoginV2CommonService {

  constructor(private router: Router, private memberService: MemberService) { }

  public navigateToAuthPage(path: string[], identifier: MemberIdentifier, route: ActivatedRoute, publicInfo?: PublicInfoResponse): void {
    saveIdentifierToStorage(identifier);
    this.router.navigate(path, { relativeTo: route, state: { identifier: identifier, publicInfo: publicInfo } });
  }

  public checkMemberPublicInfo(
    identifier: MemberIdentifier,
    success: (publicInfo: PublicInfoResponse) => any,
    notFound: (publicInfo: PublicInfoResponse) => any,
  ): void {

    this.memberService.isMember(identifier).subscribe((publicInfo) => {
      publicInfo.exists ? success(publicInfo) : notFound(publicInfo);
    });
  }
}
